import SpotifyFollowPlaylistTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/spotify/triggers/followPlaylist/InstructionsComponent';
import type {SpotifyFollowPlaylistTriggerStruct} from '@cohort/shared/apps/spotify/triggers/followPlaylist';
import {SpotifyFollowPlaylistTriggerSpec} from '@cohort/shared/apps/spotify/triggers/followPlaylist';
import SpotifyFollowPlaylistTriggerActionCtaComponent from '@cohort/wallet/apps/spotify/triggers/followPlaylist/ActionCtaComponent';
import SpotifyFollowPlaylistTriggerIntegrationDetailsComponent from '@cohort/wallet/apps/spotify/triggers/followPlaylist/DetailsComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const SpotifyFollowPlaylistTriggerIntegration: TriggerIntegration<SpotifyFollowPlaylistTriggerStruct> =
  {
    type: 'action',
    spec: SpotifyFollowPlaylistTriggerSpec,
    detailsComponent: SpotifyFollowPlaylistTriggerIntegrationDetailsComponent,
    actionCtaComponent: SpotifyFollowPlaylistTriggerActionCtaComponent,
    instructionsComponent: SpotifyFollowPlaylistTriggerIntegrationInstructionsComponent,
  };
